import { BaseModal, ModalResultType } from "../../modal/index";
import { Template, LazyTemplate } from "../../template/index";
import { AttributeKey } from "../../db/models/attributes";

export default class AuthenticationModal extends BaseModal
{
    public template = Template.lazy('/core/modals/authentication/index.html');

    constructor(title = 'Authentication', message = '')
    {
        super(title, message);
        this.data.title = title;
    }

    public beforeRender(): PromiseLike<void>
    {
        this.data.title = this.pgettext('Title', 'Authentication');
        return super.beforeRender();
    }

    public afterRender(): PromiseLike<void>
    {
        return super.afterRender();
    }

    public formSubmitted(form: HTMLFormElement): PromiseLike<void>
    {
        this.app.setFormEnabled(form, false);

        return this.app.api.public('client_login', {
            username: this.data.username,
            password: this.data.password
        }).then((result) =>
        {
            if (!result)
            {
                this.data.message = this.pgettext('Error', 'Username or password is invalid.');
            }
            else if (result.success === false && result.message != null)
            {
                this.data.message = result.message; 
            }
            else
            {
                
                this.app.userSettings = {
                    token: result.token,
                    id: result.id,
                    key: AttributeKey.CURRENT_USER,
                    language: result.language,
                }
                
                this.app.db.Attribute.put(this.app.userSettings).then(() =>
                {
                    this.close();
                }).catch((err) =>
                {   
                    console.log('test IE')
                    this.data.message = this.pgettext('Error', 'Unable to sign in. Please try again later.');
                    console.error(err);
                    throw err;
                });
            }

            this.app.setFormEnabled(form, true);
        }, (error) =>
        {
            this.data.message = this.pgettext('Error', 'Unable to sign in. Please try again later.');
            console.error(error);
            this.app.setFormEnabled(form, true);
        });
    }
}